import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'translateCut',
  pure: false,
})
export class TranslateCutPipe implements PipeTransform {
  transform(value: string, index: number): string {
    return value?.split('|')[index];
  }
}
